// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BulkSelectController from "./bulk_select_controller"
application.register("bulk-select", BulkSelectController)

import ConfirmDialogController from "./confirm_dialog_controller"
application.register("confirm-dialog", ConfirmDialogController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import GameController from "./game_controller"
application.register("game", GameController)

import HeaderController from "./header_controller"
application.register("header", HeaderController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ScrollPositionController from "./scroll_position_controller"
application.register("scroll-position", ScrollPositionController)

import SoundController from "./sound_controller"
application.register("sound", SoundController)

import WorldCupSoundController from "./world_cup_sound_controller"
application.register("world-cup-sound", WorldCupSoundController)

import RobotFilterController from "./robot_filter_controller"
application.register("robot-filter", RobotFilterController)

import CommentDeleteController from "./comment_delete_controller"
application.register("comment-delete", CommentDeleteController)

import CommentReplyController from "./comment_reply_controller"
application.register("comment-reply", CommentReplyController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import DisplayModeController from "./display_mode_controller"
application.register("display-mode", DisplayModeController)

import MemoryGameController from "./memory_game_controller"
application.register("memory-game", MemoryGameController)
